if(!customElements.get('looks-carousel')) {
  class ComponentLooksCarousel extends HTMLElement {
    constructor() {
      super();
      this.slidesWrapper = this.querySelector('.keen-slider');
      this.slides = this.slidesWrapper.children;
      this.transition = this.dataset.transition;
      this.arrows = this.dataset.arrows;
      this.autoplay = this.dataset.autoplay;
      this.automove = parseFloat(this.dataset.automove);
      this.pauseOnHover = this.dataset.pauseOnHover!=='false';
      this.slidesPerView = parseFloat(this.dataset.slidesPerView) || 1;
      this.spacing = parseFloat(this.dataset.spacing) || 0;
      this.carousel = false;
      this.isInViewPort = false;
      this.needButtonFocus = false;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initCarousel();
      }, 1);

      this.bindCustomizerEvents();
    }


    initCarousel() {
      if(window) {
        let isMobile = window.innerWidth < 608;

        if (isMobile) {
          //for each slide add class 'keen-slider-slide' to enable keen slider functionality
          Array.from(this.slides).forEach(slide => {
            slide.classList.add('keen-slider-slide');
          });

          if(this.slides.length > 1) {
            this.classList.add('prepared');
            this.carousel = new KeenSlider(this.slidesWrapper, {
              mode: "snap",
              loop: true,
              wheel: false,
              slidesPerView: this.slidesPerView,
              spacing: this.spacing,
              prevButton: this.arrows ? this.querySelector('.keen-arrow.prev') : false,
              nextButton: this.arrows ? this.querySelector('.keen-arrow.next') : false,
              customAnimation: this.transition=='fade' ? 'fade' : false,
              setContainerHeight: this.transition=='fade',
              autoplay: this.autoplay,
              automove: this.automove,
              pauseOnHover: this.pauseOnHover
            });
          } else {
            this.slidesWrapper.classList.add('initialized');
          }
        }
      }
    }

    getCurrentSlide() {
      if(this.carousel && this.carousel.currentSlide()) {
        return this.carousel.currentSlide();
      } else {
        return this.slidesWrapper.firstChild;
      }
    }

    bindCustomizerEvents() {
      if(Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e)=>{
          let index = Array.from(this.slides).findIndex(x=>x==e.target);
          if(index>=0) {
            setTimeout(()=>{
              this.carousel.moveToSlideRelative(index, true, 0)
            }, 10);
          }
        });
      }
    }

    //reinit carousel on resize
    connectedCallback() {
      window.addEventListener('resize', this.debounce(() => {
        if(this.carousel) {
          this.carousel.destroy();
          // this.classList.remove('prepared');
          // this.slidesWrapper.classList.remove('initialized');
          // Array.from(this.slides).forEach(slide => {
          //   slide.classList.remove('keen-slider-slide');
          // });
        }
        this.initCarousel();
      }, 250));
    }

    debounce(func, wait, immediate) {
      let timeout;
      return function() {
        const context = this, args = arguments;
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }
  customElements.define('looks-carousel', ComponentLooksCarousel);
}